import {create} from 'zustand';

interface ContractDataImportsAddModalState {
  open: boolean;

  contractDataImportsAddModalOpen: () => void;
  contractDataImportsAddModalClose: () => void;
}

export const useContractDataImportsAddModalStore = create<ContractDataImportsAddModalState>((set, get) => ({
  open: false,

  contractDataImportsAddModalOpen: () => set({open: true}),
  contractDataImportsAddModalClose: () => set({open: false}),
}));

export const {contractDataImportsAddModalOpen, contractDataImportsAddModalClose} =
  useContractDataImportsAddModalStore.getState();
